import api from '.';
import downloadFile from '../functions/downloadFile';

interface QueryGetCommentFile {
  commentFileId: number;
  contentType: string;
  filename: string;
}

export async function getCommentFile({
  commentFileId,
  contentType,
  filename
}: QueryGetCommentFile): Promise<void> {
  const { data } = await api.get(`comment-files/${commentFileId}`, {
    responseType: 'blob'
  });
  downloadFile({ data, contentType, filename });
}
